// _navigation.js

import { getGSAP } from './_gsap.js';

//let lenis; // Déclaration de la variable lenis en dehors de la fonction

export function initNavigation() {
  const gsap = getGSAP();
  const body = document.body;
  const burgerMenu = document.querySelector('.burger-menu');
  const nav = document.querySelector('.app-nav');
  const navContainer = document.querySelector('.main-nav-container');
  const navLinks = document.querySelectorAll('.main-nav-container li');

  let timeline;

  function createTimeline() {
    timeline = gsap.timeline({ paused: true });
    
    timeline
      .to('.app-nav-underlay', { scaleX: 1, duration: 0.6, ease: "power3.inOut" })
      .to('.app-nav-overlay', { scaleX: 1, duration: 0.6, ease: "power3.inOut" }, "-=0.3")
      .to('.overlay-border', { clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)', duration: 0.6, ease: "power1.inOut" }, "-=0.3")
      .to(navContainer, { opacity: 1, visibility: "visible", duration: 0.1 }) // Rendre le conteneur visible
      .fromTo(navLinks, 
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.3, stagger: 0.1, ease: "power2.out" },
        "-=0.1"
      );
  }

  function openNav() {
    body.classList.add('nav-is-open');
    burgerMenu.classList.add('nav-is-open');
    burgerMenu.setAttribute('aria-expanded', 'true');
    nav.classList.remove('closing');
    
    if (!timeline) createTimeline();
    timeline.play();
  }

  function closeNav() {
    if (timeline) {
      timeline.reverse().eventCallback("onReverseComplete", () => {
        body.classList.remove('nav-is-open');
        burgerMenu.classList.remove('nav-is-open');
        burgerMenu.setAttribute('aria-expanded', 'false');
        nav.classList.remove('closing');
        gsap.set(navContainer, { opacity: 0, visibility: "hidden" }); // Cacher le conteneur à la fin
      });
    } else {
      body.classList.remove('nav-is-open');
      burgerMenu.classList.remove('nav-is-open');
      burgerMenu.setAttribute('aria-expanded', 'false');
      nav.classList.remove('closing');
      gsap.set(navContainer, { opacity: 0, visibility: "hidden" });
    }
  }

  function initBurgerMenu() {
    if (burgerMenu) {
      burgerMenu.addEventListener('click', function() {
        if (body.classList.contains('nav-is-open')) {
          closeNav();
        } else {
          openNav();
        }
      });
    }
  }

  function initNavLinks() {
    navLinks.forEach(link => {
      link.addEventListener('click', closeNav);
    });
  }

  // Nouvelle fonction pour gérer l'icône de page active
  function setActiveMenuIcon() {
    var bodyId = document.body.id;
    var menuItems = document.querySelectorAll('.main-nav-container a');
    
    menuItems.forEach(function(item) {
      if(item.getAttribute('data-rel-page') === bodyId) {
        item.parentElement.classList.add('active');
      }
    });
  }

  // Initialisation
  createTimeline();
  initBurgerMenu();
  initNavLinks();
  setActiveMenuIcon();

  gsap.set(navContainer, { opacity: 0, visibility: "hidden" });
}